import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account-list" }
const _hoisted_2 = { class: "receiver-list" }
const _hoisted_3 = { class: "specify-account" }
const _hoisted_4 = { class: "receiver-list" }
const _hoisted_5 = { class: "specify-account" }
const _hoisted_6 = {
  key: 0,
  class: "receiver-list"
}
const _hoisted_7 = { class: "specify-account" }
const _hoisted_8 = {
  key: 1,
  class: "receiver-list"
}
const _hoisted_9 = { class: "specify-account" }
const _hoisted_10 = {
  key: 2,
  class: "receiver-list"
}
const _hoisted_11 = { class: "specify-account" }

import {
  ref,
  computed,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount,
  h,
  reactive,
} from "vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
interface agentKind {
  ipKind: string; // ipKind
  strIPKind: string; // strIPKind
}
// 添加新的 ref

export default /*@__PURE__*/_defineComponent({
  __name: 'AddAgentModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "refreshAgents", "success"],
  setup(__props: any, { emit: __emit }) {

const client = TelegramClient.getInstance();
//ip代理类型
const addTaskModalVisible = ref(false);
const confirmLoading = ref(false);
const ip = ref('');
const usernameVisible = ref(true);
const passwordVisible = ref(true);
const secretKeyVisible = ref(false);

const senders = ref<agentKind[]>([]);
const props = __props;

const emit = __emit;


// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});


 
const formState = reactive({
  ipkind: "",
  ip: "",
  port: "",
  username: "",
  password: "",
  secret_key:"",
});


// 处理取消添加任务
const handleAddAgentCancel = () => {
  addTaskModalVisible.value = false;
 
  console.log("handleAddAgentCancel");

};

// 加发送者选择处理函数
const handleSenderChange = (value: string) => {
  //formState.sender = value;
  console.log("handleSenderChange"+value);
  let proxy_type = parseInt(value);
  if(proxy_type == 3)
  {
     usernameVisible.value = false;
     passwordVisible.value = false;
     secretKeyVisible.value = true;
  }
  else
  {
     usernameVisible.value = true;
     passwordVisible.value = true;
     secretKeyVisible.value = false;
  }

};

// 修改发送者选择框的点击事件
const handleSenderFocus = async () => {
  if (senders.value.length === 0) {
     
  }
};

 
onMounted(async () => {

  var agentDataList:agentKind[] = [];
  var strKindArr = ["SOCKS5","HTTP","MTPROTO"];
  for (let i = 0; i < 3; i++) {
     agentDataList[i] = {ipKind:""+(i+1),strIPKind:strKindArr[i]};
  }

  senders.value = agentDataList;

  console.log("onMounted");
 
 

 }
);
 
// 修改取消操作
const handleCancel = () => {
  emit("update:visible", false);
  formState.ipkind = "";
  formState.ip = "";
  formState.port = "";
  formState.username = "";
  formState.password = "";
  formState.secret_key = "";
};


 
// 处理新增任务
const handleAddAgent = async () => {

  console.log("handleAddAgent");

  if (!formState.ipkind) {
    message.warning("请选择代理IP类型");
    return;
  }
  let proxy_type = parseInt(formState.ipkind);
  if (!formState.ip) {
    message.warning("IP或者域名不能未空");
    return;
  }
  if (!formState.port) {
    message.warning("端口不能未空");
    return;
  }
  if(proxy_type < 3)
  {
    if (!formState.username) {
      message.warning("用户名不能未空");
      return;
    }
    if (!formState.password) {
      message.warning("密码不能未空");
      return;
    }

  }
  else
  {

    if (!formState.secret_key) {
      message.warning("密钥不能未空");
      return;
    }

  }

  let port = parseInt(formState.port);
  const agentData = {
      proxy_type:proxy_type,
      address:formState.ip,
      port:port,
      username:formState.username,
      password:formState.password,
      secret_key:formState.secret_key,
    };

  const response = await client.createAgent(agentData);
  if (response.code === 1) {
     emit("refreshAgents", response.list);
     message.warning("提交成功");
     handleCancel();
  }  
  else
  {
    message.error(response.msg);
  }
 
};  

 
 

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: isOpen.value,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((isOpen).value = $event)),
    title: "增加代理",
    onCancel: handleCancel,
    onOk: handleAddAgent,
    okText: "增加",
    cancelText: "取消",
    width: "800px",
    maskClosable: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", null, "代理IP类型", -1)),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formState.ipkind,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.ipkind) = $event)),
              placeholder: "请选择代理IP类型",
              style: {"width":"98%"},
              onChange: handleSenderChange,
              onFocus: handleSenderFocus
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(senders.value, (sender) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: sender.ipKind,
                    value: sender.ipKind
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(sender.strIPKind), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("h3", null, "IP或者域名", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_input_group, { compact: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.ip,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.ip) = $event)),
                placeholder: "请输入IP或者域名",
                style: {"width":"98%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("h3", null, "端口", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_input_group, { compact: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.port,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.port) = $event)),
                placeholder: "请输入端口",
                style: {"width":"98%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ])
      ]),
      (usernameVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "用户名", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_input_group, { compact: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formState.username,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.username) = $event)),
                    placeholder: "请输入用户名",
                    style: {"width":"98%"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (passwordVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", null, "密码", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_input_group, { compact: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formState.password,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.password) = $event)),
                    placeholder: "请输入密码",
                    style: {"width":"98%"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (secretKeyVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("h3", null, "密钥", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_input_group, { compact: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formState.secret_key,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.secret_key) = $event)),
                    placeholder: "请输入密钥",
                    style: {"width":"98%"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})